module.exports = __webpack_public_path__ + "static/mentalHealth-1c417422863d1b881624114979f85bec.png";